import { render, staticRenderFns } from "./EjsListItem.vue?vue&type=template&id=1537a65e&scoped=true&"
import script from "./EjsListItem.vue?vue&type=script&lang=js&"
export * from "./EjsListItem.vue?vue&type=script&lang=js&"
import style0 from "./EjsListItem.vue?vue&type=style&index=0&id=1537a65e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1537a65e",
  null
  
)

export default component.exports